// extracted by mini-css-extract-plugin
module.exports = {"property":"MetadataRow_property__286br","value":"MetadataRow_value__1J9Bc","wrapper":"MetadataRow_wrapper__XRyyd"};